// auth
export const TOKEN_KEY = "ruminatiToken";
export const REFRESH_TOKEN_KEY = "ruminatiRefreshToken";
export const USER_KEY = "ruminatiUser";
export const VERIFIED_KEY = "ruminatiVerified";
export const SESSION_COOKIE_EXPIRY_LENGTH = 1000 * 60 * 60 * 24 * 30 * 6; // 180 days / 6 months
export const OAUTH_CODE_VERIFIER_COOKIE_KEY = "oauth_code_verifier"
export const OAUTH_STATE_COOKIE_KEY = "oauth_state"
export const OAUTH_NONCE_COOKIE_KEY = "oauth_nonce"
export const OAUTH_REGISTER_PROMO_CODE_COOKIE_KEY = "oauth_register_promo_code"
export const OAUTH_REGISTER_VISION_ORG_ID_COOKIE_KEY = "oauth_register_vision_org_id"
export const OAUTH_REGISTER_VISION_ORG_CLIENT_REFERENCE_ID_COOKIE_KEY = "oauth_register_vision_org_client_reference_id"
export const OAUTH_REGISTER_VISION_VOUCHER_POOL_COOKIE_KEY = "oauth_register_vision_voucher_pool"
export const OAUTH_REGISTER_RELATIONSHIP_ID_COOKIE_KEY = "oauth_register_relationship_id"

export const CURRENT_USER_ID_COOKIE_SUFFIX = "userid"
export const CURRENT_ORGANISATION_ID_COOKIE_SUFFIX = "current_org_id";
export const SESSION_COOKIE_SUFFIX = "session";
export const CURRENT_PROVIDER_COOKIE_SUFFIX = "provider";

// GCP
export const GOOGLE_REFRESH_TOKEN_URL = `https://securetoken.googleapis.com/v1/token`
export const GOOGLE_IDENTITY_ACCOUNTS_URL = 'https://identitytoolkit.googleapis.com/v1/accounts'

export const GOOGLE_IDENTITY_SIGNUP_PARAM = 'signUp'
export const GOOGLE_IDENTITY_SIGNUP_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_SIGNUP_PARAM}`

export const GOOGLE_IDENTITY_SIGNIN_PARAM = 'signInWithPassword'
export const GOOGLE_IDENTITY_SIGNIN_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_SIGNIN_PARAM}`

export const GOOGLE_IDENTITY_SEND_EMAIL_VERIFICATION_PARAM = 'sendOobCode'
export const GOOGLE_IDENTITY_SEND_EMAIL_VERIFICATION_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_SEND_EMAIL_VERIFICATION_PARAM}`

// N.B. this is also used for "checking" an OOB code for either password resets or email verification for some reason??? just depends on the payload???
export const GOOGLE_IDENTITY_RESET_PASSWORD_PARAM = 'resetPassword'
export const GOOGLE_IDENTITY_RESET_PASSWORD_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_RESET_PASSWORD_PARAM}`

export const GOOGLE_IDENTITY_UPDATE_PARAM = 'update'
export const GOOGLE_IDENTITY_UPDATE_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_UPDATE_PARAM}`

export const GOOGLE_IDENTITY_USER_LOOKUP_PARAM = 'lookup'
export const GOOGLE_IDENTITY_USER_LOOKUP_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_USER_LOOKUP_PARAM}`

export const GOOGLE_IDENTITY_SIGN_IN_WITH_IDP_PARAM = 'signInWithIdp'
export const GOOGLE_IDENTITY_SIGN_IN_WITH_IDP_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_SIGN_IN_WITH_IDP_PARAM}`

export const GOOGLE_IDENTITY_DELETE_PARAM = 'delete'
export const GOOGLE_IDENTITY_DELETE_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_DELETE_PARAM}`

// TypeBox
export const TB_ERROR_REQUIRED = 'Expected required property'
export const TB_ERROR_ARRAY_REQUIRED = 'Expected array length to be greater or equal to 1'
export const TB_ERROR_STRING_REQUIRED = 'Expected string length greater or equal to 1'
